import { dialogClasses } from '@mui/material/Dialog';
import { Coords } from '@/types/coords';
import { getAuthUrl } from '@/api/getUrl';
import { getCenter, getDistance } from '@/utils/numbers';

export const SCALE_CONSTANT = 8; // Arbitrary constant to scale pinch delta

export function isInput(e: MouseEvent | KeyboardEvent) {
  return (
    e.target instanceof HTMLInputElement ||
    e.target instanceof HTMLTextAreaElement
  );
}

export function goToLogin(redirect?: string) {
  // NOTE: usePath's navigate() causes an infinite auth-check loop -- need to use window.location.href
  const query = redirect ? `?redirect=${encodeURIComponent(redirect)}` : '';
  goToUrl(`${getAuthUrl()}/login${query}`);
}

export function goToUrl(url: string) {
  window.location.href = url;
}

export function isDialogsOpen() {
  return document.querySelectorAll(`.${dialogClasses.root}`).length > 0;
}

export function getPinchDelta(
  e: TouchEvent,
  touchPoint1: Coords,
  touchPoint2: Coords
) {
  const point1 = buildCoords(e.touches[0]);
  const point2 = buildCoords(e.touches[1]);

  const d1 = getDistance(touchPoint1, touchPoint2);
  const d2 = getDistance(point1, point2);

  const center = getCenter(point1, point2);

  return {
    delta: SCALE_CONSTANT * (d1 - d2),
    center,
    touchPoint1: point1,
    touchPoint2: point2,
  };
}

export function buildCoords(
  e: { clientX: number; clientY: number },
  clientRect?: DOMRect
): Coords {
  const offsetX = clientRect?.left || 0;
  const offsetY = clientRect?.top || 0;
  return [e.clientX - offsetX, e.clientY - offsetY];
}
